// extracted by mini-css-extract-plugin
module.exports = {"promoPopup":"primeday_promoPopup__N2ade","visible":"primeday_visible__i6pbh","closeButton":"primeday_closeButton__CErh2"};